import { FC } from 'react';

import { RadioChangeEvent } from 'antd';

import { FORM_FIELD_NAMES_MAP } from '@/constants/formFieldNames';
import { FICO_SCORE_TYPE_OPTIONS } from '@/constants/formFieldOptions';

import styles from './FicoScoreFormItem.module.scss';

import RadioFormItem from '../default-items/radio-form-item/RadioFormItem';

const { ficoScoreType } = FORM_FIELD_NAMES_MAP;

type TFicoScoreFormItemProps = {
	onChange?: (e: RadioChangeEvent) => void;
};

export const FicoScoreFormItem: FC<TFicoScoreFormItemProps> = ({ onChange }) => {
	return (
		<RadioFormItem
			formItemProps={{
				name: ficoScoreType,
				rules: [{ required: true, message: 'Please select your FICO credit score' }],
				className: styles['fico-score-form-item'],
			}}
			radioGroupProps={{ options: FICO_SCORE_TYPE_OPTIONS, onChange }}
		/>
	);
};
